import React, { useContext } from 'react';
import TitleBar from '../../comonents/TitleBar';
import BtnShow from '../../comonents/Buttons';
import './index.css'

import { useNavigate, useSearchParams } from 'react-router-dom';
import ArrowDownRight from '../../comonents/Icons/Arrow-down-right-sm';
import ArrowDownLeft from '../../comonents/Icons/Arrow-down-left-sm';
// import { useNavigate } from 'react-router-dom';
// import Cookies from 'js-cookie'
import { Context } from '../../context/Context'
import { EXPRESS_SERVER_URL, COOKIES_EXPIRES_TIME } from "../../config";
import axios from '../../axios'
import copy from 'copy-to-clipboard';
import Cookies from 'js-cookie'
import ArrowLeft from '../../comonents/Icons/Arrow-left';


let monthNames = ["Jan", "Feb", "Mar", "Apr",
    "May", "Jun", "Jul", "Aug",
    "Sep", "Oct", "Nov", "Dec"];

export default function Game2DashBoardDataDetail() {

    const [searchParams, setSearchParams] = useSearchParams();

    const [userAnswer, setUserAnswer] = React.useState({});

    const { gameVersion, sessionID, blockDetail, setBlockDetail } = useContext(Context);

    const navigate = useNavigate();

    const getBlock = async () => {
        const result = await axios(`${EXPRESS_SERVER_URL}/${gameVersion == 1 ? 'game1' : 'game2'}/session/${sessionID}/miners/blocks/${blockDetail.bid}`, { method: 'GET' })
        const json = await result.data
        if (json.status === 0) {
            let pbid = searchParams.get('pbid')
            let ua = json.blocks.find(block => block.pbid === pbid)
            ua = ua || {};
            setUserAnswer(ua);

            setBlockDetail(detail => {
                let newDetail = detail
                newDetail.minerBlock = json.blocks
                return newDetail
            })
        } else {
            console.log(json.err);
        }
    }

    React.useEffect(() => {
        if (!blockDetail.minerBlock) {
            getBlock();
        } else {
            let pbid = searchParams.get('pbid')
            let ua = blockDetail.minerBlock.find(block => block.pbid === pbid)
            ua = ua || {};
            setUserAnswer(ua);
        }
        // console.log(searchParams.get('a'));
    }, [])

    React.useEffect(() => {
        // console.log(searchParams.get('a'));
        if (blockDetail.minerBlock) {
            let pbid = searchParams.get('pbid')
            let ua = blockDetail.minerBlock.find(block => block.pbid === pbid)
            ua = ua || {};
            setUserAnswer(ua);
        }
    }, [blockDetail.minerBlock])

    const dateToStr = (str) => {
        var date
        date = new Date(str.substring(0, 19) + "-08:00");
        return `${date.getDate()} ${monthNames[date.getMonth()]} ${date.getFullYear()}`
    }

    const checkCorr = (correctHash, userHash, correctNonce, userNonce) => {
        return (correctHash === userHash && correctNonce === userNonce);
    }

    const renderUserAnswer = (correctHash, userHash, correctNonce, userNonce) => {
        let hash = <>Hash: {userHash} <br /></>
        let nonce = <>Nonce: {userNonce} <br /></>
        if (correctHash !== userHash) {
            hash = <>Hash: <del>{userHash}</del> {correctHash} <br /></>
        }
        if (correctNonce !== userNonce) {
            nonce = <>Nonce: <del>{userNonce}</del> {correctNonce} <br /></>
        }
        return (
            <>
                {hash}
                {nonce}
            </>
        )
    }

    return (
        <div  >

            <TitleBar backLastPage="" lastPageName="" />

            <div style={{ paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '1rem' }}>

                <div style={{ marginLeft: '1rem', paddingBottom: '1rem' }}><b>Detail of the Block Data</b></div>
                <div>Block Index: <input className='BlockIndexInput' type="number" value={blockDetail.bid} style={{ textAlign: 'center' }} /></div>

                <div className='col-md-12'>
                    <div className='row d-flex justify-content-between'  >
                        <div className='col-md-5 Block' style={{ background: 'rgb(205, 243, 130)' }}>
                            <div className='text-decoration-underline'><b>Data 1</b></div>

                            <div className="d-flex justify-content-between">
                                <div>Public ID:</div>
                                <div>
                                    {blockDetail.datas[0].pid}
                                    
                                    {/* 1231231 */}
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div>Customer ID:</div>
                                <div> 
                                    {blockDetail.datas[0].cid}
                                    {/* 123124 */}
                                </div>

                            </div>

                            <div className="d-flex justify-content-between">

                                <div> Product Quantity:</div>
                                <div>
                                    {blockDetail.datas[0].pq}
                                    {/* fdsafd */}
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div>Product Name:</div>
                                <div>
                                    {blockDetail.datas[0].pn}
                                    {/* sdfasd */}
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div>Delivery Date:</div>
                                <div>
                                    {dateToStr(blockDetail.datas[0].dd)}
                                    {/* sadfas */}
                                </div>
                            </div>
                        </div>
                        <div className='col-md-5 Block' style={{ background: 'rgb(247, 243, 130)' }}>
                            <div className='text-decoration-underline'><b>Data 2</b></div>

                            <div className="d-flex justify-content-between">
                                <div>Public ID:</div>
                                <div>
                                    {blockDetail.datas[1].pid}
                                    {/* asdfasdf */}
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div>Customer ID:</div>
                                <div>
                                    {blockDetail.datas[1].cid}
                                    {/* sadfsd */}
                                </div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div>Product Quantity:</div>
                                <div>
                                    {blockDetail.datas[1].pq}
                                    {/* dsafasd */}
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div>Product Name:</div>
                                <div>
                                    {blockDetail.datas[1].pn}
                                    {/* 321312 */}
                                </div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div>Delivery Date:</div>
                                <div>
                                    {dateToStr(blockDetail.datas[1].dd)}
                                    {/* 123124 */}
                                </div>
                            </div>
                        </div>
                        <div className='col-md-2' >
                        </div>
                    </div>
                    <div className='row d-flex justify-content-between' >
                        <div className='col-md-5 Block' style={{ background: 'rgb(247, 243, 130)' }}>
                            <div className='text-decoration-underline'><b>Data 3</b></div>

                            <div className="d-flex justify-content-between">
                                <div>Public ID:</div><div>
                                    {blockDetail.datas[2].pid}
                                    {/* 12312 */}
                                </div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div>Customer ID:</div><div>
                                    {blockDetail.datas[2].cid}
                                    {/* 12314 */}
                                </div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div>Product Quantity:</div><div>
                                    {blockDetail.datas[2].pq}
                                    {/* 124124 */}
                                </div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div>Product Name:</div><div>
                                    {blockDetail.datas[2].pn}

                                    {/* 1342124 */}
                                </div>
                            </div>
                            <div className="d-flex justify-content-between">
                                <div>Delivery Date:</div><div>
                                    {dateToStr(blockDetail.datas[2].dd)}
                                    {/* 13243245x */}
                                </div>
                            </div>
                        </div>
                        <div className='col-md-5 Block' style={{ background: 'rgb(247, 243, 130)' }}>
                            <div className='text-decoration-underline'><b>Data 3</b></div>
                            <div className="d-flex justify-content-between">
                                <div>Public ID:</div>
                                <div> 
                                    {blockDetail.datas[3].pid}
                                    {/* 1243215 */}
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div>Customer ID:</div>
                                <div> 
                                    {blockDetail.datas[3].cid}
                                {/* 1231245 */}
                                </div>
                            </div>

                            <div className="d-flex justify-content-between">
                                <div> Product Quantity:</div>
                                <div> 
                                    {blockDetail.datas[3].pq}
                                    {/* 1243 */}
                                </div>

                            </div>

                            <div className="d-flex justify-content-between">
                                <div> Product Name:</div>
                                <div>  
                                    {blockDetail.datas[3].pn}
                                    {/* 12454 */}
                                </div>

                            </div>
                            <div className="d-flex justify-content-between">
                                <div> Delivery Date:</div>
                                <div>  
                                    {dateToStr(blockDetail.datas[3].dd)}
                                    {/* 12345 */}
                                </div>
                            </div>


                        </div>
                        <div className='col-md-2' >
                        </div>
                    </div>
                </div>
                <br />
                <div className='row  '>

                    <div className="row col-12">

                        <div className="col-3 BlockListItemg2"
                            style={{
                                background: !checkCorr(
                                    blockDetail.datas[0].hash,
                                    userAnswer.hash1,
                                    blockDetail.datas[0].nonce,
                                    userAnswer.nonce1
                                ) ? "#ffb4ac" : null
                            }}
                        >
                            <div className='text-decoration-underline fw-bold'>Hash 1</div>
                            Pre. Hash: {blockDetail.ph}<br />
                            {renderUserAnswer(
                                blockDetail.datas[0].hash,
                                userAnswer.hash1,
                                blockDetail.datas[0].nonce,
                                userAnswer.nonce1
                            )}
                        </div>



                        <div className="col-3 BlockListItemg2"
                            style={{
                                background: !checkCorr(
                                    blockDetail.datas[1].hash,
                                    userAnswer.hash2,
                                    blockDetail.datas[1].nonce,
                                    userAnswer.nonce2
                                ) ? "#ffb4ac" : null
                            }}
                        >
                            <div className='text-decoration-underline fw-bold'>Hash 2</div>
                            Pre. Hash: {blockDetail.ph}<br />
                            {renderUserAnswer(
                                blockDetail.datas[1].hash,
                                userAnswer.hash2,
                                blockDetail.datas[1].nonce,
                                userAnswer.nonce2
                            )}
                        </div>


                        <div className="col-3 BlockListItemg2"
                            style={{
                                background: !checkCorr(
                                    blockDetail.datas[2].hash,
                                    userAnswer.hash3,
                                    blockDetail.datas[2].nonce,
                                    userAnswer.nonce3
                                ) ? "#ffb4ac" : null
                            }}
                        >
                            <div className='text-decoration-underline fw-bold'>Hash 3</div>
                            Pre. Hash: {blockDetail.ph}<br />
                            {renderUserAnswer(
                                blockDetail.datas[2].hash,
                                userAnswer.hash3,
                                blockDetail.datas[2].nonce,
                                userAnswer.nonce3
                            )}
                        </div>



                        <div className="col-3 BlockListItemg2"
                            style={{
                                background: !checkCorr(
                                    blockDetail.datas[3].hash,
                                    userAnswer.hash4,
                                    blockDetail.datas[3].nonce,
                                    userAnswer.nonce4
                                ) ? "#ffb4ac" : null
                            }}
                        >
                            <div className='text-decoration-underline fw-bold'>Hash 4</div>
                            Pre. Hash: {blockDetail.ph}<br />
                            {renderUserAnswer(
                                blockDetail.datas[3].hash,
                                userAnswer.hash4,
                                blockDetail.datas[3].nonce,
                                userAnswer.nonce4
                            )}
                        </div>



                    </div>


                    <div className="col-12">
                        <div className="row">
                            <div className='col-6 '>
                                <div className="row">
                                    <div className="col-6"  >
                                        <div className="d-flex justify-content-end ">
                                            {ArrowDownRight()}
                                        </div>
                                    </div>

                                    <div className="col-6 " >
                                        <div className="d-flex justify-content-start">
                                            {ArrowDownLeft()}
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className='col-6 '>
                                <div className="row">
                                    <div className="col-6">
                                        <div className="d-flex justify-content-end "  >
                                            {ArrowDownRight()}
                                        </div>
                                    </div>
                                    <div className="col-6">
                                        <div className="d-flex justify-content-start" >

                                            {ArrowDownLeft()}
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>



                    <div className=" col-12  ">

                        <div className="row">
                            <div className="col-6 d-flex justify-content-center">
                                <div className="  BlockListItemg2s2"
                                    style={{
                                        background: !checkCorr(
                                            blockDetail.hash12,
                                            userAnswer.hash12,
                                            blockDetail.nonce12,
                                            userAnswer.nonce12
                                        ) ? "#ffb4ac" : null
                                    }}
                                >
                                    <div className='text-decoration-underline fw-bold'>Hash 12</div>
                                    {renderUserAnswer(
                                        blockDetail.hash12,
                                        userAnswer.hash12,
                                        blockDetail.nonce12,
                                        userAnswer.nonce12
                                    )}
                                </div>
                            </div>


                            <div className="col-6 d-flex justify-content-center">
                                <div className="  BlockListItemg2s2"
                                    style={{
                                        background: !checkCorr(
                                            blockDetail.hash34,
                                            userAnswer.hash34,
                                            blockDetail.nonce34,
                                            userAnswer.nonce34
                                        ) ? "#ffb4ac" : null
                                    }}
                                >
                                    <div className='text-decoration-underline fw-bold'>Hash 34</div>
                                    {renderUserAnswer(
                                        blockDetail.hash34,
                                        userAnswer.hash34,
                                        blockDetail.nonce34,
                                        userAnswer.nonce34
                                    )}
                                </div>
                            </div>

                        </div>



                    </div>
                    <div className="col-12 ">


                        <div className="row">
                            <div className="col-6">
                                <div className="d-flex justify-content-end "  >
                                    {ArrowDownRight()}
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="d-flex justify-content-start" >

                                    {ArrowDownLeft()}
                                </div>
                            </div>
                        </div>


                    </div>


                    <div className="col-12 ">

                        <div className="row d-flex justify-content-center">
                            <div className=" BlockListItemg2s3"
                                style={{
                                    background: !checkCorr(
                                        blockDetail.hash1234,
                                        userAnswer.hash1234,
                                        blockDetail.nonce1234,
                                        userAnswer.nonce1234
                                    ) ? "#ffb4ac" : null
                                }}
                            >
                                <div className='text-decoration-underline fw-bold'>Hash 1234</div>
                                {renderUserAnswer(
                                    blockDetail.hash1234,
                                    userAnswer.hash1234,
                                    blockDetail.nonce1234,
                                    userAnswer.nonce1234
                                )}
                            </div>
                        </div>

                    </div>
                </div>

            </div>
            <div className='Btns_Back'>


                <input type="button" className='Btn_Back' value='Back' onClick={() => navigate(-1)}></input>
            </div>
            <br />


        </div>

    )
}